import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { phrasalVerbsData, getDataForDifficulty } from '../courses/data/vocabulary/phrasalVerbs';

export default function PhrasalVerbsTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : phrasalVerbsData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
